__turbopack_context__.v({
  "className": "inter_f90b89b1-module__Z5cBja__className",
});
